import { connect } from 'react-redux';
import { compose } from 'recompose';

import AllUsersList from './AllUsersList';
import { queryAllUsersGQL } from '../graphql';
import { setUserIdThunk } from '../actions';

import {
  getCurrentSelectedUserId,
  getShowTerminatedUsers,
  getDepartmentId,
  getDistrictId,
} from '../selectors';

const mapStateToProps = (state) => {
  return {
    currentUserId: getCurrentSelectedUserId(state),
    excludeTerminatedUsers: !getShowTerminatedUsers(state),
    districtId: getDistrictId(state),
    departmentId: getDepartmentId(state),
  };
};

const mapDispatchToProps = {
  setUserIdAction: setUserIdThunk,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(
  withRedux,
  queryAllUsersGQL,
);

export default enhance(AllUsersList);
